/* ============================================================
   SEW4ME SHOPIFY THEME — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Sticky header shadow ──────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── Scroll reveal ─────────────────────────────────────────
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => observer.observe(el));
  }

  // ── Mobile menu toggle ────────────────────────────────────
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open);
    });
    // close on outside click
    document.addEventListener('click', (e) => {
      if (!menuToggle.contains(e.target) && !mobileMenu.contains(e.target)) {
        mobileMenu.classList.remove('open');
      }
    });
  }

  // ── Cart item count ───────────────────────────────────────
  const cartCountEl = document.querySelector('.cart-count');
  if (cartCountEl) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count > 0) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.style.display = 'flex';
        }
      });
  }

  // ── Cart: quick-add product ───────────────────────────────
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = '...';
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        btn.textContent = '✓';
        setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 1500);
        // update count
        const r = await fetch('/cart.js');
        const cart = await r.json();
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.style.display = 'flex';
        }
      } catch (err) {
        btn.textContent = '+';
        btn.disabled = false;
      }
    });
  });

  // ── Quantity selector (Produktseite) ─────────────────────
  document.querySelectorAll('.qty-btn--minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-selector').querySelector('.qty-input');
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
  });
  document.querySelectorAll('.qty-btn--plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-selector').querySelector('.qty-input');
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // ── Image thumbnails (Produktseite) ───────────────────────
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.full || thumb.src;
        mainImg.alt = thumb.alt;
      });
    });
  }

  // ── Smooth accordion ──────────────────────────────────────
  document.querySelectorAll('.accordion-item').forEach(item => {
    const hdr  = item.querySelector('.accordion-header');
    const body = item.querySelector('.accordion-body');
    if (hdr && body) {
      hdr.addEventListener('click', () => {
        const open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
        hdr.setAttribute('aria-expanded', open);
      });
    }
  });

  // ── Category tabs (Shop) ──────────────────────────────────
  const catTabs = document.querySelectorAll('.cat-tab');
  catTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const isActive = tab.classList.contains('active');
      catTabs.forEach(t => t.classList.remove('active'));
      if (isActive) {
        // Deselect: show all products
        document.querySelectorAll('.product-item').forEach(item => {
          item.style.display = '';
        });
      } else {
        tab.classList.add('active');
        const target = tab.dataset.cat;
        document.querySelectorAll('.product-item').forEach(item => {
          const cat = item.dataset.cat;
          item.style.display = cat.split(' ').indexOf(target) !== -1 ? '' : 'none';
        });
      }
    });
  });

  // ── Dynamic quote blocks ──────────────────────────────────
  if (typeof ZITATE !== 'undefined') {
    const INTERVAL = 60000;
    const FADE = 600;
    const blocks = [
      document.getElementById('quote-block-1'),
      document.getElementById('quote-block-2')
    ];
    blocks.forEach(b => {
      if (!b) return;
      b.querySelector('blockquote').style.transition = 'opacity ' + FADE + 'ms ease';
      b.querySelector('cite').style.transition = 'opacity ' + FADE + 'ms ease';
    });
    const indices = [];
    const start0 = Math.floor(Math.random() * ZITATE.length);
    indices[0] = start0;
    indices[1] = (start0 + Math.floor(ZITATE.length / 2)) % ZITATE.length;

    function setQuote(blockEl, idx) {
      if (!blockEl) return;
      const bq = blockEl.querySelector('blockquote');
      const cite = blockEl.querySelector('cite');
      bq.style.opacity = '0';
      cite.style.opacity = '0';
      setTimeout(() => {
        bq.textContent = ZITATE[idx].text;
        cite.textContent = ZITATE[idx].autor;
        bq.style.opacity = '1';
        cite.style.opacity = '1';
      }, FADE);
    }
    setQuote(blocks[0], indices[0]);
    setQuote(blocks[1], indices[1]);
    setInterval(() => {
      indices[0] = (indices[0] + 1) % ZITATE.length;
      indices[1] = (indices[0] + Math.floor(ZITATE.length / 2)) % ZITATE.length;
      setQuote(blocks[0], indices[0]);
      setQuote(blocks[1], indices[1]);
    }, INTERVAL);
  }

  // ── Community Moodboard ────────────────────────────────────
  const moodboard = document.getElementById('moodboard');
  if (moodboard) {
    const INTERVAL_MB = 6000;
    const FADE_OUT = 700;
    const srcs = Array.from(moodboard.querySelectorAll('[data-src]')).map(el => el.dataset.src);
    const slots = Array.from(moodboard.querySelectorAll('.mb-slot'));
    if (srcs.length && slots.length) {
      // Preload
      let loaded = 0;
      srcs.forEach(src => {
        const img = new Image();
        img.onload = img.onerror = () => { loaded++; if (loaded === srcs.length) startMoodboard(); };
        img.src = src;
      });
      let pool = [...srcs];
      function shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
      }
      function startMoodboard() {
        shuffle(pool);
        slots.forEach((slot, i) => {
          const img = document.createElement('img');
          img.src = pool[i % pool.length];
          img.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;object-position:center top;transition:opacity '+FADE_OUT+'ms ease-in-out;';
          slot.appendChild(img);
        });
        let srcIndex = slots.length;
        slots.forEach((slot, i) => {
          setTimeout(() => {
            setInterval(() => {
              const img = slot.querySelector('img');
              if (!img) return;
              img.style.opacity = '0';
              setTimeout(() => {
                img.src = pool[srcIndex % pool.length];
                srcIndex++;
                void img.offsetWidth;
                img.style.opacity = '1';
              }, FADE_OUT);
            }, INTERVAL_MB);
          }, i * Math.round(INTERVAL_MB / slots.length));
        });
      }
    }
  }

  // ── Footer year ───────────────────────────────────────────
  const yearEl = document.getElementById('footer-year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

});

/* ── Zitate ──────────────────────────────────────────────── */
var ZITATE = [
  { text: "»Eleganz ist Ablehnung.«", autor: "— Coco Chanel" },
  { text: "»Mode ist das, was man trägt. Stil ist das, was man ist.«", autor: "— Edna Woolman Chase" },
  { text: "»Ich entwerfe keine Kleider. Ich entwerfe Träume.«", autor: "— Ralph Lauren" },
  { text: "»In Kleidern, die ich selbst genäht habe, fühle ich mich am meisten ich selbst.«", autor: "— Anonym" },
  { text: "»Kleider machen Leute – aber Kleider, die man selbst gemacht hat, machen Charakter.«", autor: "— Anonym" },
  { text: "»Eleganz ist nicht darum, aufzufallen, sondern darum, im Gedächtnis zu bleiben.«", autor: "— Giorgio Armani" },
  { text: "»Wer gut näht, spart nicht Zeit – der schenkt sie sich.«", autor: "— Anonym" },
  { text: "»Die Mode verändert sich, der Stil bleibt.«", autor: "— Coco Chanel" },
  { text: "»Ein Kleid, das man selbst genäht hat, trägt man mit einer ganz besonderen Haltung.«", autor: "— Anonym" },
  { text: "»Schönheit beginnt in dem Moment, in dem du entscheidest, du selbst zu sein.«", autor: "— Coco Chanel" },
  { text: "»Nähen ist Meditation mit sichtbarem Ergebnis.«", autor: "— Anonym" },
  { text: "»Stil ist eine einfache Art zu sagen, wer man ist, ohne sprechen zu müssen.«", autor: "— Rachel Zoe" },
  { text: "»Ich wollte Frauen nicht nur schöner machen – ich wollte ihnen Mut geben.«", autor: "— Christian Dior" },
  { text: "»Mode schafft Träume, Handwerk erfüllt sie.«", autor: "— Anonym" },
  { text: "»Das Schönste, was eine Frau tragen kann, ist ihr Selbstbewusstsein – und ein selbst genähtes Kleid.«", autor: "— Anonym" }
];
